import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  kassenbucher: [],
  loading: false,
  loaded: false,
  error: null
}

// getters
const getters = {
  kassenbucher (state) {
    return state.kassenbucher
  },
  kassenbucherKasse: (state) => (kasse) => {
    let kassenbucher = []
    state.kassenbucher.forEach(kassenbuch => {
      if (kassenbuch.kasse === kasse) {
        kassenbucher.push(kassenbuch)
      }
    })
    return kassenbucher
  },
  kassenbuch: (state) => (id) => {
    return state.kassenbucher.find(kassenbuch => kassenbuch.id === id)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadKassenbucher ({commit}) {
    commit('setLoading', true)
    console.log('Kassenbücher laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('kassenbucher').orderBy('datum', 'desc')
    .onSnapshot(snapshot => {
      const kassenbucher = []
      snapshot.forEach(doc => {
        kassenbucher.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedKassenbucher', kassenbucher)
        commit('setLoading', false)
        commit('setLoaded', true)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createKassenbuch ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('kassenbucher').add(payload)
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteKassenbuchData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('kassenbucher').doc(payload).delete()
    // .then(() => {
    //   commit('setLoading', false)
    //   commit('deleteKassenbuch', payload)
    // })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateKassenbuchData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('kassenbucher').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateKassenbuch', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedKassenbucher (state, payload) {
    state.kassenbucher = payload
  },
  createKassenbuch (state, payload) {
    state.kassenbucher.push(payload)
  },
  updateKassenbuch (state, payload) {
    const kassenbuch = state.kassenbucher.find(kassenbuch => {
      return kassenbuch.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        kassenbuch[key] = payload[key]
      }
    })
  },
  deleteKassenbuch (state, payload) {
    let array = state.kassenbucher
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.kassenbucher = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/kassenbucher_alt.js